import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { i18n } from '@lingui/core';
import { en, fr, de, it, ja, pt, es } from 'make-plural/plurals';
import { messages } from '../locale/en/messages.es.js';
import { messages as messages$1 } from '../locale/fr/messages.es.js';
import { messages as messages$2 } from '../locale/de/messages.es.js';
import { messages as messages$3 } from '../locale/it/messages.es.js';
import { messages as messages$4 } from '../locale/ja/messages.es.js';
import { messages as messages$5 } from '../locale/pt/messages.es.js';
import { messages as messages$6 } from '../locale/es/messages.es.js';
import { Languages } from '../enums/languages.es.js';

var _i18nCatalogs, _i18n$loadLocaleData;
var i18nCatalogs = (_i18nCatalogs = {}, _defineProperty(_i18nCatalogs, Languages.English, messages), _defineProperty(_i18nCatalogs, Languages.French, messages$1), _defineProperty(_i18nCatalogs, Languages.German, messages$2), _defineProperty(_i18nCatalogs, Languages.Italian, messages$3), _defineProperty(_i18nCatalogs, Languages.Japanese, messages$4), _defineProperty(_i18nCatalogs, Languages.Portuguese, messages$5), _defineProperty(_i18nCatalogs, Languages.Spanish, messages$6), _i18nCatalogs);
i18n.loadLocaleData((_i18n$loadLocaleData = {}, _defineProperty(_i18n$loadLocaleData, Languages.English, {
  plurals: en
}), _defineProperty(_i18n$loadLocaleData, Languages.French, {
  plurals: fr
}), _defineProperty(_i18n$loadLocaleData, Languages.German, {
  plurals: de
}), _defineProperty(_i18n$loadLocaleData, Languages.Italian, {
  plurals: it
}), _defineProperty(_i18n$loadLocaleData, Languages.Japanese, {
  plurals: ja
}), _defineProperty(_i18n$loadLocaleData, Languages.Portuguese, {
  plurals: pt
}), _defineProperty(_i18n$loadLocaleData, Languages.Spanish, {
  plurals: es
}), _i18n$loadLocaleData));

export { i18nCatalogs };
